var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTrainDirection = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 48,
  viewBox: "0 0 32 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2E70FF",
  fillRule: "evenodd",
  d: "M15.844 16.494c-8.7 0-15.753 7.053-15.753 15.753S7.144 48 15.844 48s15.753-7.053 15.753-15.753-7.052-15.753-15.753-15.753m.015-13.002L9.763 14.324a14.04 14.04 0 0 1 6.096-1.38q3.19 0 6.54 1.38z"
})));
export default SvgTrainDirection;